module.exports = __webpack_public_path__ + "static/media/details.d67214d0.svg";